export const tariffTypeEnum = {
  fixed: 'fixed',
  oneOffRequests: 'oneOffRequests'
};

export const tariffTypes = {
  fixed: 'Закреплённое',
  oneOffRequests: 'Разовые заявки'
};
